import {Box, styled} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import PropTypes from 'prop-types';

const SETTINGS_HEADER_COLOUR = '#0dad95';
const SETTINGS_TEXT_COLOUR = '#0f172a';

export const SettingsSection = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

const SettingsSectionBase = ({header, subHeader, headerIcon, children}) => {
    const hasHeaderContent = !!header || !!subHeader || !!headerIcon;

    if (!hasHeaderContent) {
        return (
            <Box>
                {children}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                borderRadius: 1.5,
                overflow: 'hidden',
                border: '1px solid rgba(15, 23, 42, 0.08)',
                backgroundColor: '#ffffff',
                boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Box
                sx={{
                    px: 2.75,
                    py: 1.75,
                    backgroundColor: '#ffffff',
                    color: SETTINGS_TEXT_COLOUR,
                    borderBottom: '1px solid rgba(13, 173, 149, 0.12)',
                }}
            >
                <Stack
                    direction="column"
                    gap={0.5}
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                    }}
                >
                    <Stack flexDirection="row" gap={1} alignItems="center">
                        {headerIcon && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: SETTINGS_HEADER_COLOUR,
                                    backgroundColor: 'rgba(13, 173, 149, 0.12)',
                                    border: '1px solid rgba(13, 173, 149, 0.16)',
                                    borderRadius: 1,
                                    minWidth: 32,
                                    minHeight: 32,
                                }}
                            >
                                {headerIcon}
                            </Box>
                        )}
                        {header && (
                            <Typography variant="h6" fontWeight="bold" sx={{color: SETTINGS_TEXT_COLOUR}}>
                                {header}
                            </Typography>
                        )}
                    </Stack>
                    {subHeader && (
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: 'rgba(15, 23, 42, 0.68)'
                            }}
                        >
                            {subHeader}
                        </Typography>
                    )}
                </Stack>
            </Box>
            <Box
                sx={{
                    px: 2.75,
                    py: 2.5,
                    background: 'linear-gradient(180deg, rgba(13, 173, 149, 0.025) 0%, rgba(255, 255, 255, 0) 100px), #ffffff',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

SettingsSectionBase.propTypes = {
    header: PropTypes.node,
    headerIcon: PropTypes.node,
    subHeader: PropTypes.node,
    children: PropTypes.node,
};

export default SettingsSectionBase;
